var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?[_c('d-header',{attrs:{"actions":[{
        label: _vm.$t('save'),
        primary: true,
        color: 'is-primary',
        action: _vm.submitForm
      }],"fluid":"","breadcrumbs":false}},[_c('h1',{staticClass:"title"},[_c('d-previous-btn',{attrs:{"path":'/properties/' + _vm.$route.params.property + '/property-inspections'}}),_vm._v("\n        "+_vm._s(_vm.model.date)+"\n      ")],1)]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"edit","model":_vm.model,"property-id":_vm.propertyId}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }